import script from "./AddressPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddressPage.vue?vue&type=script&setup=true&lang=ts"

import "./AddressPage.vue?vue&type=style&index=0&id=5fceaa9b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fceaa9b"]])

export default __exports__